export const GET_SHIPPING_COST_REQUEST="GET_SHIPPING_COST_REQUEST"
export const GET_SHIPPING_COST_SUCCESS="GET_SHIPPING_COST_SUCCESS"
export const GET_SHIPPING_COST_FAILURE="GET_SHIPPING_COST_FAILURE"